import { Group, PasswordInput, Stack, TextInput, Button, Alert } from '@mantine/core';
import { AxiosError } from 'axios';

import { useSignIn } from '..';
import { useSignInForm } from '../hooks/useSignInForm';

export const SignInForm = () => {
  const form = useSignInForm();
  const signIn = useSignIn();

  const error = signIn.error as AxiosError<{ error: string }> | null;
  const errorMessage = error?.response?.data?.error || error?.message;

  const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    form.setFieldValue('username', event.currentTarget.value);
    if (signIn.error) {
      signIn.reset();
    }
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    form.setFieldValue('password', event.currentTarget.value);
    if (signIn.error) {
      signIn.reset();
    }
  };

  return (
    <form
      onSubmit={form.onSubmit(({ username, password }) => signIn.mutate({ username, password }))}
    >
      <Stack>
        {errorMessage && (
          <Alert color="red" title="Error" onClose={() => signIn.reset()}>
            {errorMessage}
          </Alert>
        )}

        <TextInput
          required
          label="Username"
          placeholder="Your username"
          value={form.values.username}
          onChange={handleUsernameChange}
          error={form.errors.username && form.errors.username.toString()}
        />

        <PasswordInput
          required
          label="Password"
          placeholder="Your password"
          value={form.values.password}
          onChange={handlePasswordChange}
          error={form.errors.password && form.errors.password}
        />
      </Stack>

      <Group justify="right" mt="xl">
        <Button loading={signIn.isLoading} type="submit">
          Sign in
        </Button>
      </Group>
    </form>
  );
};
